import(/* webpackMode: "eager" */ "/tmp/build_4ec3fd76/node_modules/.pnpm/next@15.3.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"interSans\"}");
;
import(/* webpackMode: "eager" */ "/tmp/build_4ec3fd76/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_4ec3fd76/src/components/SplashScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/tmp/build_4ec3fd76/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourRenderer"] */ "/tmp/build_4ec3fd76/src/features/tour/components/TourRenderer.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build_4ec3fd76/src/providers/providers.tsx");
